import React from 'react';
import { Section } from '../ui/Section';
import { Gift, ListChecks, MessageSquareQuote, DoorOpen } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: 'B1',
    title: 'Checklist de Documentación',
    desc: 'Organización documental para los momentos de mayor exigencia.',
    Icon: ListChecks
  }, {
    num: 'B2',
    title: 'Banco de Frases para Diagnósticos',
    desc: 'Estructuras de conversación listas para tu próxima consulta difícil.',
    Icon: MessageSquareQuote
  }, {
    num: 'B3',
    title: 'Protocolo de Bienvenida',
    desc: 'Para que cada paciente nuevo llegue ordenado a su primera consulta.',
    Icon: DoorOpen
  }];
  return <Section className="bg-slate-900 text-white relative overflow-hidden" data-id="element-20">
      <div className="absolute top-0 left-0 w-full h-1 bg-amber-400" data-id="element-21"></div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-22">
        <div className="text-center mb-8 md:mb-10" data-id="element-23">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-amber-500/20 text-amber-400 mb-4 md:mb-6 hover:scale-110 transition-transform cursor-default" data-id="element-24">
            <Gift className="w-6 h-6 md:w-8 md:h-8" data-id="element-25" />
          </div>
          <h2 className="text-xs md:text-sm font-bold text-amber-400 tracking-widest uppercase mb-1 md:mb-2" data-id="element-26">
            Incluidos Gratis
          </h2>
          <h3 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4" data-id="element-27">
            3 Bonos Estratégicos
          </h3>
          <p className="text-sm md:text-base text-slate-300" data-id="element-28">
            Sin costo extra — incluidos en ambas ofertas
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-3 md:gap-4" data-id="element-29">
          {bonuses.map((bono, i) => {
          const Icon = bono.Icon;
          return <div key={i} className="relative bg-slate-800 border border-slate-700 rounded-2xl p-4 md:p-5 hover:border-amber-500/50 transition-colors group" data-id="element-30">
                <span className="absolute top-3 right-3 text-[10px] md:text-xs font-black text-slate-600" data-id="element-31">
                  {bono.num}
                </span>
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-amber-500 text-slate-900 flex items-center justify-center mb-3 group-hover:bg-amber-400 transition-colors" data-id="element-32">
                  <Icon className="h-5 w-5 md:h-6 md:w-6" aria-hidden="true" data-id="element-33" />
                </div>
                <div className="flex items-center gap-2 mb-1" data-id="element-34">
                  <h4 className="font-bold text-sm md:text-base leading-tight" data-id="element-35">
                    {bono.title}
                  </h4>
                </div>
                <span className="inline-block bg-amber-500/20 text-amber-400 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded uppercase tracking-wider mb-2" data-id="element-36">
                  Gratis
                </span>
                <p className="text-xs md:text-sm text-slate-400" data-id="element-37">{bono.desc}</p>
              </div>;
        })}
        </div>

        <div className="mt-8 md:mt-10 text-center" data-id="element-38">
          <p className="text-xl md:text-2xl font-bold text-slate-300" data-id="element-39">
            VALOR TOTAL:{' '}
            <span className="line-through text-slate-500" data-id="element-40">$45.000</span> —{' '}
            <span className="text-amber-400 animate-pulse" data-id="element-41">GRATIS</span>
          </p>
        </div>
      </div>
    </Section>;
}